import { InjectionToken, inject } from '@angular/core';
import { WINDOW_REFERENCE } from './window-reference';

export type Gtm = (object: any) => void;

export function getGtm(window: Window): Gtm {
  if (window) {
    if (!window['dataLayer']) {
      window['dataLayer'] = [];
    }

    return (object: any) => {
      window['dataLayer'].push(object as any);
    };
  }

  return null;
}

export const GTM = new InjectionToken<Gtm>('gtm', {
  providedIn: 'root',
  factory: () => getGtm(inject(WINDOW_REFERENCE))
});
